import React from 'react';
import { LoginState } from '../types/Session';
import { useAuthenticateUser } from '../hooks/useAuthenticateUser';
import UserProfileLoggedOut from './UserProfileLoggedOut';
import UserProfileSigningIn from './UserProfileSigningIn';
import UserProfileLoggedIn from './UserProfileLoggedIn';

const UserProfileDropdown = () => {
  const {
    name,
    email,
    signinState,
    login,
    fullLogout,
    authProvider,
    salesforceToken,
    startSalesforceLinkLogin,
  } = useAuthenticateUser();

  if (signinState === LoginState.LoggedOut) {
    return <UserProfileLoggedOut login={login} />;
  }

  if (signinState === LoginState.SigningIn) {
    return <UserProfileSigningIn />;
  }

  if (
    signinState === LoginState.SalesforceConnected ||
    signinState === LoginState.LoggedIn
  ) {
    return (
      <UserProfileLoggedIn
        name={name}
        email={email}
        authProvider={authProvider}
        hasSalesforceAccess={!!salesforceToken}
        onConnectSalesforce={startSalesforceLinkLogin}
        fullLogout={fullLogout}
      />
    );
  }

  return null;
};

export default UserProfileDropdown;